import { apiInterfaceForJson } from "../common/apiManager";

// Incoming duplicate submissions (Settings → Incoming Duplicates, admin only)
export const fetchIncomingDuplicates = (params = {}) => {
    const query = new URLSearchParams();
    if (params.page) query.set("page", params.page);
    if (params.limit) query.set("limit", params.limit);
    if (params.status) query.set("status", params.status);
    if (params.affiliate) query.set("affiliate", params.affiliate);
    const qs = query.toString();
    return apiInterfaceForJson(`/incoming-duplicate/v1${qs ? `?${qs}` : ""}`, "GET");
};

export const fetchIncomingDuplicatesPendingCount = () => {
    return apiInterfaceForJson("/incoming-duplicate/v1/pending-count", "GET");
};

export const fetchIncomingDuplicateAffiliates = () => {
    return apiInterfaceForJson("/incoming-duplicate/v1/affiliates", "GET");
};

export const mergeIncomingDuplicate = (id, options = {}) => {
    return apiInterfaceForJson(`/incoming-duplicate/v1/${id}/merge`, "POST", options);
};

export const dismissIncomingDuplicate = (id) => {
    return apiInterfaceForJson(`/incoming-duplicate/v1/${id}/dismiss`, "POST");
};
